import { Controller } from "@hotwired/stimulus";

// The player lives in the layout, outside the card, so the card cannot
// target it with a Stimulus action. It announces on window instead.
export default class extends Controller {
  static values = { meditation: Object };

  play() {
    window.dispatchEvent(new CustomEvent("player:open", { detail: this.meditationValue }));
  }
}
